module.exports = __webpack_public_path__ + "img/title2.5f78b298.png";